import { Form } from "antd";
import { IBaseViews } from "app/based/baseViews/BaseViews";
import { ElementType } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "reflect-metadata";

export function HigherOrderComponent({
  Component,
  componentProps,
}: {
  Component: ElementType;
  componentProps?: IBaseViews;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  return (
    <Component
      {...componentProps}
      location={location}
      navigate={navigate}
      form={form}
    />
  );
}
